






import { Component, Vue } from 'vue-property-decorator';

/** document hooks */
const tagSpacing: any = 4;

@Component({
	name: 'ScrollPane'
})
/** docs */
export default class extends Vue {
	/** document hooks */
	public get scrollWrapper(): any {
		return this.$refs.scrollContainer;
	}

	/** document hooks */
	public mounted(): any {
		this.scrollWrapper.addEventListener('scroll', this.emitScroll.bind(this), true);
	}

	/** document hooks */
	public beforeDestroy(): any {
		this.scrollWrapper.removeEventListener('scroll', this.emitScroll.bind(this));
	}

	/** document hooks */
	private handleScroll(e: WheelEvent): any {
		const eVal: any = e;
		const eventDelta: any = eVal.wheelDelta || -e.deltaY * 40;
		const { scrollWrapper }: any = this;

		scrollWrapper.scrollLeft = Number(scrollWrapper.scrollLeft) + Number(eventDelta) / 4;
	}

	/** document hooks */
	private emitScroll(): any {
		this.$emit('scroll');
	}

	/** document hooks */
	public moveToTarget(currentTag: HTMLElement): any {
		const container: any = this.$refs.scrollContainer;
		const containerWidth: any = container.offsetWidth;
		const { scrollWrapper }: any = this;
		const tagList: any = this.$parent.$refs.tag as any[];

		let firstTag: any = null;
		let lastTag: any = null;

		// find first tag and last tag
		if (tagList.length > 0) {
			// eslint-disable-next-line prefer-destructuring
			firstTag = tagList[0];
			lastTag = tagList[tagList.length - 1];
		}

		if (firstTag === currentTag) {
			scrollWrapper.scrollLeft = 0;
		} else if (lastTag === currentTag) {
			scrollWrapper.scrollLeft = scrollWrapper.scrollWidth - containerWidth;
		} else {
			// find preTag and nextTag
			const currentIndex: any = tagList.findIndex((item: any): any => item === currentTag);
			const prevTag: any = tagList[Number(currentIndex) - 1];
			const nextTag: any = tagList[Number(currentIndex) + 1];
			// the tag's offsetLeft after of nextTag
			const afterNextTagOffsetLeft: number = Number(nextTag.$el.offsetLeft) + Number(nextTag.$el.offsetWidth) + Number(tagSpacing);
			// the tag's offsetLeft before of prevTag
			const beforePrevTagOffsetLeft: number = Number(prevTag.$el.offsetLeft) - Number(tagSpacing);

			const scrollMax: number = Number(scrollWrapper.scrollLeft) + Number(containerWidth);

			if (afterNextTagOffsetLeft > scrollMax) {
				scrollWrapper.scrollLeft = afterNextTagOffsetLeft - containerWidth;
			} else if (beforePrevTagOffsetLeft < scrollWrapper.scrollLeft) {
				scrollWrapper.scrollLeft = beforePrevTagOffsetLeft;
			}
		}
	}
}
